<template>
  <!-- 邮费管理 -->
  <div class="postage">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['商城管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          >新增邮费规则</el-button
        >
      </template>
    </crumbs-bar>

    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="状态"
          style="width: 100px; margin-right: 10px"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="已启用" value="Y"></el-option>
          <el-option label="已禁用" value="N"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 10px"
          clearable
          placeholder="区域名称"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleRefresh"
          >搜索</el-button
        >
      </template>
    </search-bar>

    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" type="index">
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="规则编号"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        align="center"
        show-overflow-tooltip
        label="区域编号"
      >
      </el-table-column>
      <el-table-column
        prop="province"
        label="省"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="city"
        label="市"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="area"
        label="区"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="minPrice"
        label="最低免邮金额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="price"
        label="邮费"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 'Y'">已启用</el-tag>
          <el-tag type="warning" v-if="scope.row.status == 'N'">已禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-show="scope.row.status == 'N'"
            type="success"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 'Y')"
            >启用</el-button
          >
          <el-button
            v-show="scope.row.status == 'Y'"
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 'N')"
            >禁用</el-button
          >
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 1)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 新增邮费规则 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">邮费规则</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="120px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="地址" prop="address">
              <el-cascader
                v-model="addForm.address"
                placeholder="选择地址(可搜索)"
                :options="$store.state.citys"
                :props="{
                  value: 'code',
                  label: 'label',
                  checkStrictly: true,
                  emitPath: false,
                }"
                ref="address"
                @change="setAddress"
                style="width: 100%"
                filterable
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="最低免邮金额" prop="minPrice">
              <el-input v-model="addForm.minPrice"></el-input>
            </el-form-item>
            <el-form-item label="邮费" prop="price">
              <el-input v-model="addForm.price"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "postage",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**select选中项 */
      selectedList: [],
      // 搜索项
      searchForm: {
        name: "",
        status: "",
      },
      /**新增drawer */
      addDrawer: false,
      /**新增分类表单 */
      addForm: {
        id: 0,
        address: "",
        minPrice: 0,
        price: 0,
        province: "",
        city: "",
        area: "",
      },
      addFormRule: {
        address: [mustFill],
        minPrice: [mustFill],
        price: [mustFill],
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取表格 */
    getTableData() {
      let data = {
        type: "GetRegionaList",
        status: this.searchForm.status,
        strWhere: this.searchForm.name,
        pageSize: this.pageSize,
        pageIndex: this.currPage,
      };
      var proc = "proc_RegionaAdmin";
      var type = "ReturnList";
      this.$requestSys({
        url:
          "members/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          console.log(res);
          this.allPage = 1;
          this.tableData = [];
          if (res.flag == 0) {
            this.allPage = res.recordCount || res.data.length;
            this.tableData = (res.data || []).map((item) => ({
              id: item.keyid,
              address: item.qybh,
              minPrice: item.xzAmount,
              price: item.postage,
              province: item.province,
              city: item.city,
              area: item.area,
              status: item.beactive,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**更改状态 */
    handleStatus(row, status) {
      let tips = "确定要启用吗？";
      let type = "success";
      let data = {
        type: "UpdateRegiona",
        keyid: row.id,
        status: status,
      };
      if (status == "Y") {
        tips = "确定要启用吗？";
        type = "success";
      } else if (status == "N") {
        tips = "确定要禁用吗？";
        type = "warning";
      } else if (status == 1) {
        tips = "确定要删除吗？";
        type = "error";
        data = {
          type: "DLTRegiona",
          keyid: row.id,
        };
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let proc = "proc_RegionaAdmin";
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "main/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          }).then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    /**新增/编辑分类 */
    handleAdd(row) {
      this.clearForm();
      if (row) {
        for (let key in this.addForm) {
          this.addForm[key] = row[key];
        }
      }
      this.addDrawer = true;
    },
    // 设置选中的地址
    setAddress() {
      let list = this.$refs.address.getCheckedNodes()[0].pathLabels;
      this.addForm.province = list[0] || "";
      this.addForm.city = list[1] || "";
      this.addForm.area = list[2] || "";
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.addForm = {
        id: 0,
        address: "",
        minPrice: 0,
        price: 0,
        province: "",
        city: "",
        area: "",
      };
      this.addDrawer = false;
    },
    /**提交新增分类 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            type: "SavetRegiona",
            keyid: this.addForm.id,
            qybh: this.addForm.address,
            payTypeList: "",
            province: this.addForm.province,
            city: this.addForm.city,
            area: this.addForm.area,
            postage: this.addForm.price,
            listName: "",
            amount: this.addForm.minPrice,
          };
          // let proc = "proc_RegionaAdmin";
          // let type = "ReturnNumber";
          // this.$requestSys({
          //   url:
          //     "main/ashx/ReturnJson.ashx?type=" +
          //     type +
          //     "&json=" +
          //     encodeURIComponent(JSON.stringify(data)) +
          //     "&proc=" +
          //     proc,
          //   method: "post",
          // }).then((res) => {

          this.$requestSys({
            url: "Base/SaveLogisticsRule",
            method: "post",
            data,
          }).then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.clearForm();
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.postage {
  width: 100%;
  height: 100%;
}
</style>
